import { useEffect, useState } from 'react'

/**
 * Returns the id of the section currently crossing the reading line
 * (a band a little above the middle of the window).
 */
export const useScrollSpy = (ids: Array<string>, rootMargin = '-38% 0px -56% 0px'): string | null => {
    const [active, setActive] = useState<string | null>(null)
    const key = ids.join('|')

    useEffect(() => {
        const elements = key
            .split('|')
            .map(id => document.getElementById(id))
            .filter((element): element is HTMLElement => Boolean(element))

        if (!elements.length) return

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) setActive(entry.target.id)
            })
        }, { rootMargin })

        elements.forEach(element => observer.observe(element))

        return () => observer.disconnect()
    }, [key, rootMargin])

    return active
}
